import React, { Component } from 'react';
import { Container, Row, Col, Form } from "react-bootstrap";
import { Button } from "@mui/material";
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import axios from "axios";
import Swal from "sweetalert2";
import Select from '../../Components/PCSelect';
import WeekRangeSelect from '../../Components/WeekRangeSelect';
import { getWeekDetails, formatDisplayWeek } from '../../helper';
import Detail from './Detail';
import Summary from './Summary';
import PageHeader from '../../Pages/admin/shared/PageHeader';
import PrintButton from '../../Pages/admin/shared/PrintButton';
import FilterCard from '../../Pages/admin/shared/FilterCard';

/* Shops Warehouse Delivery report.

   Restores legacy Reports/MS_RPT_ShopsWarehouseDelivery.aspx. Its two radio modes map to:
     Detail  -> services/report/shopsWarehouseDelivery.php  (new; Name | Delivery + Total)
     Summary -> services/report/warehouseBalance.php        (existing; reused deliberately,
                see Summary.js for why nothing is recomputed)

   Filters mirror the legacy page's controls: Shop (multi), Warehouse, From/To week and a
   Group By selector (`_cmbGroupBy`). */

class ShopsWarehouseDelivery extends Component {
    constructor(props) {
        super(props);
        this.state = {
            WarehouseList: [],
            WeeklyWarehouse: "",
            ShopList: [],
            Shop_Name: [],
            // Default to the current week so the dropdown opens on it; the report still
            // waits for "View", matching every other report in the app.
            From_Week: getWeekDetails().weekId,
            To_Week: getWeekDetails().weekId,
            reportView: "detail",
            GroupBy: { value: "shop", label: "Shop" },
            GroupByList: [
                { value: "shop", label: "Shop" },
                { value: "warehouse", label: "Warehouse" }
            ],
            showReport: false,
            ReportDetails: {},
            PC_GRP_ATT: localStorage.getItem('PC_GRP_ATT'),
            OTHER_DATA: localStorage.getItem('OTHER_DATA')
        }
    }

    componentDidMount() {
        this.getWarehouse()
        this.getShopList()
    }

    async getWarehouse() {
        try {
            const res = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetAllWarehouse.php`);
            const warehouseData = res.data
            let WarehouseList = []
            if (warehouseData.success === 1) {
                for (let i = 0; i < warehouseData.data.length; i++) {
                    const warehouse = warehouseData.data[i];
                    WarehouseList.push({
                        value: warehouse.WAREHOUSE_ID,
                        label: warehouse.WAREHOUSE_NAME
                    })
                }
            }
            // Only one warehouse exists in practice — preselect it so the report is one click.
            this.setState({
                WarehouseList,
                WeeklyWarehouse: WarehouseList.length === 1 ? WarehouseList[0] : this.state.WeeklyWarehouse
            })
        } catch (error) {
            console.error('getWarehouse error :>> ', error);
        }
    }

    // Same scoping rule as the Profit & Loss report: a user pinned to an account
    // (PC_GRP_ATT) may only see that account's partner shops, never the full list.
    async getShopList() {
        let ShopList = []
        const { PC_GRP_ATT, OTHER_DATA } = this.state;

        if (PC_GRP_ATT && PC_GRP_ATT !== 'null') {
            if (OTHER_DATA) {
                try {
                    const parseData = JSON.parse(OTHER_DATA);
                    const partnerShops = parseData.ShopPartnerDetail ? JSON.parse(parseData.ShopPartnerDetail) : [];
                    for (let i = 0; i < partnerShops.length; i++) {
                        ShopList.push(partnerShops[i].ShopName)
                    }
                } catch (error) {
                    console.error('getShopList error :>> ', error);
                }
            }
        } else {
            try {
                const res = await axios.get(`${process.env.REACT_APP_BASE_URL}services/query/PCGetShops.php`);
                const shopData = res.data
                if (shopData.success === 1) {
                    for (let i = 0; i < shopData.data.length; i++) {
                        const shop = shopData.data[i];
                        ShopList.push({ value: shop.PC_SP_ID, label: shop.SP_NAME })
                    }
                }
            } catch (error) {
                console.error('getShopList error :>> ', error);
            }
        }

        this.setState({ ShopList })
    }

    handleChange(fieldName, evnt) {
        let targetValue = ""
        switch (fieldName) {
            case 'WeeklyWarehouse':
            case 'Shop_Name':
            case 'GroupBy':
                targetValue = evnt
                break;
            default:
                targetValue = evnt.target.value
                break;
        }

        // Any filter change invalidates what is on screen — drop it so Detail figures are
        // never read under a Summary heading, or under the wrong Group By.
        this.setState({ [fieldName]: targetValue, showReport: false, ReportDetails: {} })
    }

    async viewReport() {
        const { WeeklyWarehouse, From_Week, To_Week, reportView, GroupBy, Shop_Name } = this.state;

        if (!WeeklyWarehouse || !WeeklyWarehouse.value || From_Week === "" || To_Week === "") {
            Swal.fire('Error', 'Please select Warehouse and From / To week', 'error')
            return
        }

        // A multi-select of shops becomes a plain integer CSV; the endpoint sanitizes each
        // value with intval() before it reaches IN(...). Empty means every shop.
        let shopIDs = ""
        for (let i = 0; i < (Shop_Name || []).length; i++) {
            shopIDs += `${Shop_Name[i].value},`
        }
        shopIDs = shopIDs.slice(0, -1)

        this.props.toggleLoader && this.props.toggleLoader(true)
        try {
            if (reportView === 'summary') {
                // Reuse the Warehouse Balance endpoint — see Summary.js.
                const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/warehouseBalance.php`, {
                    WH_ID: WeeklyWarehouse.value,
                    From_Week,
                    To_Week
                });
                if (res.data.success === 1) {
                    this.setState({ ReportDetails: res.data.data, showReport: true })
                } else {
                    this.setState({ showReport: false, ReportDetails: {} })
                    Swal.fire('No Data', res.data.message || 'No record found!', 'info')
                }
            } else {
                const res = await axios.post(`${process.env.REACT_APP_BASE_URL}services/report/shopsWarehouseDelivery.php`, {
                    WH_ID: WeeklyWarehouse.value,
                    Shop_IDs: shopIDs,
                    From_Week,
                    To_Week,
                    GroupBy: GroupBy ? GroupBy.value : 'shop'
                });
                if (res.data.success === 1) {
                    this.setState({ ReportDetails: res.data.data, showReport: true })
                } else {
                    this.setState({ showReport: false, ReportDetails: {} })
                    Swal.fire('No Data', res.data.message || 'No record found!', 'info')
                }
            }
        } catch (error) {
            console.error('shopsWarehouseDelivery error :>> ', error);
            Swal.fire('Error', 'Could not load the report.', 'error')
        }
        this.props.toggleLoader && this.props.toggleLoader(false)
    }

    weekRangeLabel() {
        const from = formatDisplayWeek(this.state.From_Week);
        const to = formatDisplayWeek(this.state.To_Week);
        return from === to ? from : `${from}  |  ${to}`;
    }

    render() {
        const isSummary = this.state.reportView === 'summary';

        return (
            <Container>
                <PageHeader breadcrumb="section" title="Shops Warehouse Delivery"
                    right={<PrintButton content={() => this.newRef} disabled={this.state.showReport !== true} />} />

                <FilterCard>
                    <Row>
                        <Col style={{ textAlign: "center" }} >
                            <FormControl>
                                <RadioGroup
                                    row
                                    aria-labelledby="reportView-label"
                                    name="reportView"
                                    value={this.state.reportView}
                                    sx={{ '& .MuiSvgIcon-root': { fontSize: 14 } }}
                                >
                                    <FormControlLabel value="detail" control={<Radio />} label="Detail" onChange={this.handleChange.bind(this, 'reportView')} />
                                    <FormControlLabel value="summary" control={<Radio />} label="Summary" onChange={this.handleChange.bind(this, 'reportView')} />
                                </RadioGroup>
                            </FormControl>
                        </Col>
                    </Row>
    
                    <Row style={{ alignItems: 'center' }} >
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Warehouse</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    style={{ height: '32px' }}
                                    value={this.state.WeeklyWarehouse}
                                    options={this.state.WarehouseList}
                                    onChange={this.handleChange.bind(this, "WeeklyWarehouse")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Shop <span style={{ fontSize: '11px', color: '#777' }} >(all if blank)</span></Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    isClearable={true}
                                    isMulti
                                    isDisabled={isSummary}
                                    style={{ height: '32px' }}
                                    value={this.state.Shop_Name}
                                    options={this.state.ShopList}
                                    onChange={this.handleChange.bind(this, "Shop_Name")}
                                />
                            </Form.Group>
                        </Col>
                        <Col md={3}>
                            <Form.Group className="mb-3" >
                                <Form.Label>Group By</Form.Label>
                                <Select menuPortalTarget={document.body}
                                    menuPlacement="auto"
                                    isDisabled={isSummary}
                                    style={{ height: '32px' }}
                                    value={this.state.GroupBy}
                                    options={this.state.GroupByList}
                                    onChange={this.handleChange.bind(this, "GroupBy")}
                                />
                            </Form.Group>
                        </Col>
                    </Row>
                </FilterCard>

                {/*
                  * Week fields sit on their own row at md={3} each — the width every other report
                  * uses (AccountBalance, ProfitAndLoss, ShopPayment, WarehouseBalance all use a
                  * row of md={3} controls). This report had five controls sharing one 12-column
                  * line, which left the week fields at md={2}: too narrow for a full
                  * "14 Jul 2026 - 20 Jul 2026" label, so it truncated.
                  */}
                <Row style={{ alignItems: 'center' }} >
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label><span>From Week</span></Form.Label>
                            <WeekRangeSelect
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                value={this.state.From_Week}
                                onChange={this.handleChange.bind(this, "From_Week")}
                            />
                        </Form.Group>
                    </Col>
                    <Col md={3}>
                        <Form.Group className="mb-3" >
                            <Form.Label><span>To Week</span></Form.Label>
                            <WeekRangeSelect
                                menuPortalTarget={document.body}
                                menuPlacement="auto"
                                value={this.state.To_Week}
                                onChange={this.handleChange.bind(this, "To_Week")}
                            />
                        </Form.Group>
                    </Col>
                </Row>

                <Row>
                    <Col>
                        <Button className="add-button" onClick={this.viewReport.bind(this)} variant="contained" size='small' >View</Button>
                    </Col>
                </Row>

                {this.state.showReport === true && !isSummary ?
                    <Detail
                        ref={el => (this.newRef = el)}
                        ReportDetails={this.state.ReportDetails}
                        WeekRange={this.weekRangeLabel()}
                    />
                    :
                    ""
                }

                {this.state.showReport === true && isSummary ?
                    <Summary
                        ref={el => (this.newRef = el)}
                        ReportDetails={this.state.ReportDetails}
                        WarehouseName={this.state.WeeklyWarehouse ? this.state.WeeklyWarehouse.label : ""}
                        WeekRange={this.weekRangeLabel()}
                    />
                    :
                    ""
                }
            </Container >
        );
    }
}

export default ShopsWarehouseDelivery;
